import { getViaWebWorker, get } from './API'
import * as constants from '../../mixins/constants'

export const getKeyAccountPartnerProfile = (params) => {
  const uri = constants.API.rest_api.get_ka_profile
  return getViaWebWorker(uri, params, { baseURL: global.$_VUE_APP_REST_API, token_required: true })
}

export const getPartnerProfile = (params) => {
  const uri = constants.API.rest_api.get_partner
  return getViaWebWorker(uri, params, { baseURL: global.$_VUE_APP_REST_API, token_required: true })
}

export const getOrderList = (params) => {
  const uri = constants.API.rest_api.get_partner_booking_list
  return getViaWebWorker(uri, params, { baseURL: global.$_VUE_APP_REST_API, token_required: true })
}

export const getOrderMetaV3 = ({ limit_time, ...rest }) => {
  const uri = constants.API.partner.order_meta

  const params = {
    ...rest
  }

  if (limit_time && limit_time !== 'CUSTOM') {
    params.limit_time = limit_time
  }

  return get(uri, params, {
    token_required_header: true
  })
}
